
<component
  v-if="!responsive"
  :is="computedTag"
  :class="computedClasses"
  role="button"
  :aria-label="computedLabel"
  :to="to"
  @click.passive="$emit('click', $event)">
  <icon v-if="glyph !== ''" :glyph="glyph"/>
  <span class="caption" v-if="computedValue">
    {{computedValue}}
  </span>
</component>

<component
  v-else
  :is="computedTag"
  :class="computedClasses"
  role="button"
  :to="to"
  :aria-label="computedLabel"
  v-tooltip="computedValue"
  data-c-tooltip-class="responsive-btn"
  @click.passive="$emit('click', $event)">
  <icon v-if="glyph !== ''" :glyph="glyph"/>
  <span class="caption">
    {{computedValue}}
  </span>
</component>
